import gsap, { Power2 } from 'gsap';
import { GetBy } from '../_app/cuchillo/core/Element';

const PRELOAD_AHEAD = 2; // cuántos videos cargar por delante

export default class VisorVideos {
  _blur = 0;
  get blur() { return this._blur; }
  set blur(__n) {
    this._blur = __n;
    this.container.style.setProperty('--blur', `${this._blur}px`);
  }

  _overlay = 0;
  get overlay() { return this._overlay; }
  set overlay(__n) {
    this._overlay = __n;
    this.container.style.setProperty('--overlay', `${this._overlay}`);
  }

  _scale = 0;
  get scale() { return this._scale; }
  set scale(__n) {
    this._scale = __n;
    this.container.style.setProperty('--scale', `${this._scale}`);
  }

  _grayscale = 0;
  get grayscale() { return this._grayscale; }
  set grayscale(__n) {
    this._grayscale = __n;
    this.container.style.setProperty('--grayscale', `${this._grayscale}`);
  }

  constructor(__dom) {
    this.hasFocus = false;
    this.current = -1;
    this.container = __dom;
    this.videos = [...GetBy.selector('figure', __dom)].map(
      (figure, i) => new VisorVideo__Video(figure, i, this)
    );
  }

  change(__n) {
    if (this.current === __n) return;

    // Ocultar el actual
    if (this.current >= 0) this.videos[this.current].hide();

    this.current = __n;

    // Cancelar cargas que ya no tienen prioridad
    this.videos.forEach((v, i) => {
      const isAhead = i > __n && i <= __n + PRELOAD_AHEAD;
      if (!isAhead && i !== __n && !v.isLoaded) {
        v.cancel();
      }
    });

    // Mostrar el actual (cargará si no está listo)
    this.videos[__n].show(() => this._preloadAhead(__n));
  }

  _preloadAhead(__from) {
    // Carga secuencial: primero __from+1, luego __from+2
    const loadNext = (index) => {
      if (index >= this.videos.length || index > __from + PRELOAD_AHEAD) return;
      // Solo si seguimos en el mismo "current" (no ha habido cambio manual)
      if (this.current !== __from) return;

      const video = this.videos[index];
      if (video.isLoaded) {
        loadNext(index + 1);
      } else {
        video.load(() => loadNext(index + 1));
      }
    };

    loadNext(__from + 1);
  }

  show() {
    if(this.hasFocus) {
      this.container.style.opacity = 1;
    } else {
      gsap.to(this.container, { alpha: 1, duration: 0.4, ease: Power2.easeIn });
    }
    
  }

  hide() {
    if(this.hasFocus) {
      this.container.style.opacity = 0;
    } else {
      gsap.to(this.container, { alpha: 0, duration: 0.4, ease: Power2.easeIn });
    }
  }

  dispose() {
    this.videos.forEach(v => v.dispose());
    this.videos = [];
    this.container = null;
  }
}


class VisorVideo__Video {
  constructor(dom, index, visor) {
    this.visor = visor;
    this.index = index;
    this.isLoaded = false;
    this.isLoading = false;
    this.isShow = false;
    this.container = dom;
    this.img = GetBy.selector('img', dom)[0];
    this.video = GetBy.selector('video', dom)[0];
    this._src = this.video.getAttribute('src');
    this.video.removeAttribute('src'); // quitamos src hasta que toque cargar
    this._onLoaded = null;
  }

  load(onComplete = null) {
    if (this.isLoaded) {
      onComplete?.();
      return;
    }
    if (this.isLoading) {
      const prev = this._onLoaded;
      this._onLoaded = () => { prev?.(); onComplete?.(); };
      return;
    }

    this.isLoading = true;
    this._onLoaded = onComplete;

    this.video.addEventListener('canplaythrough', this._handleLoaded.bind(this), { once: true });
    this.video.src = this._src;  // asignamos src aquí
    this.video.preload = 'auto';
    this.video.load();
  }

  _handleLoaded() {
    this.isLoaded = true;
    this.isLoading = false;

    this.width = this.video.videoWidth;
    this.height = this.video.videoHeight;
    // Opacity 0 en lugar de remove() — sin reflow
    /*if (this.img) {
      this.img.style.opacity = '0';
      this.img.style.pointerEvents = 'none';
    }*/

    this._onLoaded?.();
    this._onLoaded = null;
  }

  cancel() {
    if (!this.isLoading || this.isLoaded) return;
    this.video.removeEventListener('canplaythrough', this._handleLoaded);
    // Vaciamos src y llamamos load() — esto sí aborta la descarga en todos los browsers
    this.video.src = '';
    this.video.load();
    this.isLoading = false;
    this._onLoaded = null;
  }

  show(onReady = null) {
    if (this.isShow) return;
    this.isShow = true;

    const reveal = () => {
      this.video.play().catch(() => {});
      onReady?.()
    };

    if (this.isLoaded) {
      reveal();
    } else {
      this.load(reveal);
    }

    //if(this.visor.hasFocus) {
    //  this.container.style.opacity = 1;
   // } else {
      gsap.killTweensOf(this.container);
      gsap.to(this.container, {
        alpha: 1,
        duration: 0.2,
        ease: Power2.easeIn});
   // }
  }

  hide() {
    if (!this.isShow) return;
    this.isShow = false;

   /* if(this.visor.hasFocus) {
      this.container.style.opacity = 0;
      this.video.pause();
    } else {*/
        gsap.killTweensOf(this.container);
        gsap.to(this.container, {
        alpha: 0,
        duration: 0.3,
        ease: Power2.easeIn,
        onComplete: () => {
          this.video.pause();
        }
      });
   // }
  }

  dispose() {
    this.cancel();
    this.video.pause();
    this.video.src = '';
    this.video.load();
    this.container = null;
    this.video = null;
    this.img = null;
  }
}
